// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "b2e79d4bf1c6a4d19ec7" + ".chunk.js";
};